// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"PowerARange_TheComp__xr_F0"};